/**
 * Hook: useIsProTenant()
 *
 * Returns true if the current tenant has a Pro-tier subscription on ANY vertical.
 * Used to gate premium intake/scanning features that work across verticals
 * (dental, wellness/benessere, hair, beauty, generic).
 *
 * Detection layers (any match → Pro):
 *   1. subscription_tier ends with "_pro" or equals "pro" / "dental_pro" / "benessere_pro"
 *   2. selected_plan_id contains "_pro_"
 *   3. features list contains "smart_intake" or "smart_prescription" (Pro signals)
 *   4. tenant_tier === "pro"
 */
import { useAuth } from "../App";

export const useIsProTenant = () => {
  const { user } = useAuth();
  if (!user) return false;

  const tier   = (user.tenant_tier || user.subscription_tier || "").toString().trim().toLowerCase();
  const planId = (user.selected_plan_id || "").toString().toLowerCase();
  const features = Array.isArray(user.features) ? user.features : [];

  if (tier === "pro" || tier === "dental_pro" || tier === "benessere_pro" || tier === "wellness_pro") return true;
  if (tier.endsWith("_pro")) return true;
  if (planId.includes("_pro_")) return true;
  if (features.includes("smart_intake")) return true;
  if (features.includes("smart_prescription")) return true; // Dental Pro signal

  return false;
};
